import { useOfferingSetup_BasicInfoRoute_BasicInfoQuery } from '../../graphql';
import { useCheckPrivatePlacementTrait } from './useCheckPrivatePlacementTrait';

export const useBasicInfoQuery = ({ offeringId }: { offeringId: string | undefined }) => {
  const hasPrivatePlacementTrait = useCheckPrivatePlacementTrait();

  const { data, ...rest } = useOfferingSetup_BasicInfoRoute_BasicInfoQuery({
    variables: {
      offeringId: offeringId!,
      includePrivatePlacementOfferings: hasPrivatePlacementTrait,
    },
    skip: !offeringId,
    fetchPolicy: 'network-only',
  });

  return {
    data: {
      offering: data?.privateOfferings?.items?.[0] ?? null,
      publishedOffering: data?.publishedOfferings?.items?.[0] ?? null,
    },
    ...rest,
  };
};
